import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';
import cx from 'classnames';
import _ from 'lodash';
import { querySelectOptions } from '../advancedSearch/formData';
import courtsData from '../../data/courts';
import './RefineSearch.less';

const refineSearchParametersMap = {
  court_type: 'Court type',
  keys: 'Fulltext keywords',
  judge_name: 'Judge',
  assets: 'Assets (in USD)',
  liabilities: 'Liabilities (in USD)',
  nature_of_suit: 'Nature of Suit',
  chapter: 'Chapter',
  query: 'Query',
  court: 'Court',
  date_filed: 'Case filed',
};

const courtsMap = _.keyBy(courtsData, 'code');
const querySelectOptionsMap = _.keyBy(querySelectOptions, 'value');
const courtTypesMap = {
  all: 'All',
  bankruptcy: 'Bankruptcy',
  civil: 'Civil',
  criminal: 'Criminal',
  appellate: 'Appellate',
  national: 'National',
};

const getHumanReadableFacetCategoryItemKey = (facetCategoryItemKey, facetCategory) => {
  if (facetCategory === 'query') {
    return querySelectOptionsMap[facetCategoryItemKey].label;
  }
  if (facetCategory === 'court') {
    return courtsMap[facetCategoryItemKey].name;
  }
  if (facetCategory === 'court_type') {
    return courtTypesMap[facetCategoryItemKey];
  }
  return facetCategoryItemKey;
};

const RefineSearch = ({ facets, advancedSearchFilter, onSearchAdvancedFilings }) => {
  const [isOpen, setIsOpen] = useState(true);

  const arrowIconClass = cx({
    glyphicon: true,
    'glyphicon-triangle-bottom': isOpen,
    'glyphicon-triangle-right': !isOpen,
  });

  const refineSearchDetails = Object.keys(facets)
    .sort()
    .map((facetCategory) => {
      const facetCategoryItemsObject = facets[facetCategory];

      return (
        <div key={facetCategory}>
          {!_.isEmpty(facetCategoryItemsObject) && <h5>{refineSearchParametersMap[facetCategory]}</h5>}
          {Object.keys(facetCategoryItemsObject)
            .sort()
            .map((facetCategoryItemKey, refineSearchParameterValueIndex) => {
              const humanReadableFacetCategoryItemKey = getHumanReadableFacetCategoryItemKey(
                facetCategoryItemKey,
                facetCategory
              );
              const facetCategoryItemValue = facetCategoryItemsObject[facetCategoryItemKey];
              const isArrayKey = [
                'query',
                'court_code',
                'assets',
                'industry',
                'liabilities',
                'nature_of_suit',
                'chapter',
                'case_type',
              ].includes(facetCategory);

              return facetCategoryItemsObject[facetCategoryItemKey] === -1 ? (
                <div key={`refine-search-parameter-value-${refineSearchParameterValueIndex}`}>
                  <span
                    className="facet-link"
                    onClick={() => {
                      delete advancedSearchFilter[facetCategory];
                      onSearchAdvancedFilings(advancedSearchFilter);
                    }}
                  >
                    (-)
                  </span>{' '}
                  {humanReadableFacetCategoryItemKey}
                </div>
              ) : (
                <div
                  className="facet-link"
                  key={`selected-refine-search-parameter-value-${refineSearchParameterValueIndex}`}
                  onClick={() =>
                    onSearchAdvancedFilings({
                      ...advancedSearchFilter,
                      [facetCategory]: isArrayKey ? [facetCategoryItemKey] : facetCategoryItemKey,
                    })
                  }
                >
                  {`${humanReadableFacetCategoryItemKey} (${facetCategoryItemValue})`}
                </div>
              );
            })}
        </div>
      );
    });

  return (
    <div className="refine-search-summary">
      <div onClick={() => setIsOpen(!isOpen)}>
        <h5 className="refine-search-title">
          <span className={arrowIconClass} /> Refine Search
        </h5>
      </div>
      <Collapse in={isOpen}>
        <div className="refine-search-details-container">{refineSearchDetails}</div>
      </Collapse>
    </div>
  );
};

RefineSearch.propTypes = {
  facets: PropTypes.object.isRequired,
  advancedSearchFilter: PropTypes.object.isRequired,
  onSearchAdvancedFilings: PropTypes.func.isRequired,
};

export default RefineSearch;



// WEBPACK FOOTER //
// ./src/components/refineSearch/RefineSearch.jsx